<template>
  <div class="fill-height">
    <v-content class="fill-height">
      <v-container fluid>
        <Loader v-if="loading"/>
        <template v-else>
          <v-toolbar dense color="transparent" flat class="mb-3" style="z-index: 2">
            <v-toolbar-title>
              Телеграм чаты
            </v-toolbar-title>
          </v-toolbar>
          <Placeholder v-if="!list.length"/>
          <v-card v-else rounded>
            <v-list two-line>
              <div v-for="(chat, index) in list" :key="'chat_'+index">
                <v-divider
                    v-if="index > 0"
                    :key="'chat_line_'+index"
                    inset
                ></v-divider>
                <v-list-item
                    :key="'chat_item_'+index"
                    exact
                    :to="{name: 'chatDetail', params: {id: chat.id}}"
                >
                  <v-list-item-avatar
                      color="blue-grey lighten-4"
                  >
                    <v-icon color="blue-grey">mdi-chat-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="chat.name"/>
                    <v-list-item-subtitle>Зарегистрирован {{ getDate(chat.created) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-list>
          </v-card>
        </template>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: 'Chats',
  data: () => ({
    loading: true,
    list: []
  }),
  components: {
    Loader:    ()  => import('@/components/placeholder/Loader'),
    Placeholder:    ()  => import('@/components/placeholder/EmptyChats'),
  },
  methods: {
    getChats() {
      this.loading = true;
      this.$http.get(`${this.$serverApiLink}chats/list`).then(
          response => {
            this.list = response.data.data;
            this.loading = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.loading = false;
          }
      );
    },
    getDate(unix) {
      let date = new Date(unix * 1000);
      let hours = date.getHours();
      let minutes = "0" + date.getMinutes();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      let formattedTime = hours + ':' + minutes.substr(-2);
      let formattedDate = day + '-' + month + '-' + year;
      return formattedDate + ' ' + formattedTime;
    },
  },
  mounted() {
    this.getChats();
  }
}
</script>